
import { Component, Watch } from 'vue-property-decorator';
import { ServiceQueueItemModel } from '@/libs/Api';
import { serviceQueueItemsStore } from '@/libs/service-queue-items/+state/store';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { CrudAction, CrudResponseAction } from '@/libs/core/+state/models/crud-action';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import moment from 'moment';
import Page from '@/Page.vue';
import { auditsStore } from '@/libs/audits/+state/store';
import { AuditBasicModel, AuditModel } from '@/libs/Api';

@Component({})
export default class ServiceQueueDialog extends Page {
    dialog = false;
    errorDialog = false;
    errorDialogMessage = '';
    auditBasicMap: Record<string, AuditBasicModel> = {};
    pendingAuditIds: Set<string> = new Set();

    get items(): ServiceQueueItemModel[] {
        return (serviceQueueItemsStore.useGetter(CrudGetter.Data) ?? []) as ServiceQueueItemModel[];
    }

    get serviceQueueRunningCount(): number {
        const items = (serviceQueueItemsStore.useGetter(CrudGetter.Data) ?? []) as ServiceQueueItemModel[];
        return items.filter((x: any) => x.isDone === false).length;
    }

    mounted() {
        this.$store.subscribe((mutation) => {
            if (mutation.type === serviceQueueItemsStore.getActionName(CrudResponseAction.CreateSuccess)) {
                this.loadItems();
            }
        });
        this.loadItems();
    }

    @Watch('items', { deep: true, immediate: true })
    async onItemsChanged() {
        // Vytáhni pouze auditId, která nejsou v cache a nejsou pending
        const auditIds = this.items
            .map(item => item.auditId)
            .filter((id): id is string => !!id && !(id in this.auditBasicMap) && !this.pendingAuditIds.has(id));
        if (auditIds.length === 0) return;
        // Označ id jako pending
        auditIds.forEach(id => this.pendingAuditIds.add(id));
        try {
            await auditsStore.dispatch(
                CrudAction.GetAllBasic,
                createCrudQueryPayload(
                    undefined,
                    [{ field: 'id', op: 'in', comparand: auditIds }]
                )
            );
            const audits = (auditsStore.useGetter(CrudGetter.DataBasic) ?? []) as AuditBasicModel[];
            for (const audit of audits) {
                if (audit && audit.id) {
                    this.$set(this.auditBasicMap, audit.id, audit);
                    this.pendingAuditIds.delete(audit.id);
                }
            }
            // Pokud nějaké id nebylo vráceno, odeber je z pending, aby bylo možné je zkusit znovu později
            auditIds.forEach(id => {
                if (!this.auditBasicMap[id]) {
                    this.pendingAuditIds.delete(id);
                }
            });
        } catch (e) {
            // V případě chyby odeber id z pending, aby bylo možné je zkusit znovu
            auditIds.forEach(id => this.pendingAuditIds.delete(id));
        }
    }

    openDialog() {
        this.dialog = true;
    }

    loadItems() {
        serviceQueueItemsStore.dispatch(
            CrudAction.GetAll,
            createCrudQueryPayload({ field: 'createdAt', order: 'desc' }, undefined, { pageIndex: 1, pageSize: 50 })
        );
    }

    formatDate(date: string | null | undefined) {
        return date ? moment(date).format('DD.MM.YYYY HH:mm:ss') : '-';
    }

    showError(item: any) {
        this.errorDialogMessage = item.errorMessage;
        this.errorDialog = true;
    }
}
